import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  description2: {
    id: 'seo_phrasebook_description2',
  },
  noResults: {
    id: 'seo_phrasebook_search_no_results',
  },
  noResultsDescription: {
    id: 'seo_phrasebook_search_no_results_description',
  },
  typeIn: {
    id: 'communicate_type_instruction',
  },
});

export const ar = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_ar',
  },
  description1: {
    id: 'seo_phrasebook_description1_ar',
  },
});

export const da = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_da',
  },
  description1: {
    id: 'seo_phrasebook_description1_da',
  },
});

export const de = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_de',
  },
  description1: {
    id: 'seo_phrasebook_description1_de',
  },
});

export const el = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_el',
  },
  description1: {
    id: 'seo_phrasebook_description1_el',
  },
});

export const en = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_en',
  },
  description1: {
    id: 'seo_phrasebook_description1_en',
  },
});

export const en_us = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_en_us',
  },
  description1: {
    id: 'seo_phrasebook_description1_en',
  },
});

export const es = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_es',
  },
  description1: {
    id: 'seo_phrasebook_description1_es',
  },
});

export const es_mx = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_es_mx',
  },
  description1: {
    id: 'seo_phrasebook_description1_es_mx',
  },
});

export const fa = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_fa',
  },
  description1: {
    id: 'seo_phrasebook_description1_fa',
  },
});

export const fr = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_fr',
  },
  description1: {
    id: 'seo_phrasebook_description1_fr',
  },
});

export const he = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_he',
  },
  description1: {
    id: 'seo_phrasebook_description1_he',
  },
});

export const hi = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_hi',
  },
  description1: {
    id: 'seo_phrasebook_description1_hi',
  },
});

export const id = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_id',
  },
  description1: {
    id: 'seo_phrasebook_description1_id',
  },
});

export const is = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_is',
  },
  description1: {
    id: 'seo_phrasebook_description1_is',
  },
});

export const it = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_it',
  },
  description1: {
    id: 'seo_phrasebook_description1_it',
  },
});

export const jp_full = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_jp_full',
  },
  description1: {
    id: 'seo_phrasebook_description1_jp_full',
  },
});

export const jp_romaji = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_jp_romaji',
  },
  description1: {
    id: 'seo_phrasebook_description1_jp_romaji',
  },
});

export const ko = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_ko',
  },
  description1: {
    id: 'seo_phrasebook_description1_ko',
  },
});

export const mn = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_mn',
  },
  description1: {
    id: 'seo_phrasebook_description1_mn',
  },
});

export const nl = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_nl',
  },
  description1: {
    id: 'seo_phrasebook_description1_nl',
  },
});

export const no = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_no',
  },
  description1: {
    id: 'seo_phrasebook_description1_no',
  },
});

export const pl = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_pl',
  },
  description1: {
    id: 'seo_phrasebook_description1_pl',
  },
});

export const pt = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_pt',
  },
  description1: {
    id: 'seo_phrasebook_description1_pt',
  },
});

export const pt_br = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_pt_br',
  },
  description1: {
    id: 'seo_phrasebook_description1_pt_br',
  },
});

export const ru = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_ru',
  },
  description1: {
    id: 'seo_phrasebook_description1_ru',
  },
});

export const sl = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_sl',
  },
  description1: {
    id: 'seo_phrasebook_description1_sl',
  },
});

export const sv = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_sv',
  },
  description1: {
    id: 'seo_phrasebook_description1_sv',
  },
});

export const sw = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_sw',
  },
  description1: {
    id: 'seo_phrasebook_description1_sw',
  },
});

export const th = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_th',
  },
  description1: {
    id: 'seo_phrasebook_description1_th',
  },
});

export const tr = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_tr',
  },
  description1: {
    id: 'seo_phrasebook_description1_tr',
  },
});

export const uk = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_uk',
  },
  description1: {
    id: 'seo_phrasebook_description1_uk',
  },
});

export const yo = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_yo',
  },
  description1: {
    id: 'seo_phrasebook_description1_yo',
  },
});

export const zh_cn = defineMessages({
  phrasebook: {
    id: 'seo_phrasebook_zh_cn',
  },
  description1: {
    id: 'seo_phrasebook_description1_zh_cn',
  },
});
